import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  status: {
    type: "text",
    name: "status",
    label: "Status",
    disabled: true,
  },
  lineNo: {
    name: "lineNo",
    label: "Line No",
    type: "number",
    // errorMsg: "",
    required: true,
    disabled: true,
  },
  poNumber: {
    name: "poNumber",
    label: "PO Number",
    type: "text",
    disabled: true,
    // errorMsg: "",
  },
  extPONumber: {
    name: "extPONumber",
    label: "Ext PO Number",
    type: "text",
    // errorMsg: "",
  },
  poLineNo: {
    name: "poLineNo",
    label: "Po Line No",
    type: "number",
    disabled: true,
  },
  asnLineNo: {
    name: "asnLineNo",
    label: "ASN Line No",
    type: "number",
    disabled: true,
  },
  returnCode: {
    name: "returnCode",
    label: "Return Code",
    type: "text",
    disabled: true,
  },
  coLineNo: {
    name: "coLineNo",
    label: "CO Line No",
    type: "number",
    disabled: true,
  },
  skuCode: {
    name: "skuCode",
    label: "SKU Code",
    type: "text",
    errorMsg: "SKU code is required",
    required: true,
    disabled: true,
  },
  packType: {
    name: "packType",
    label: "Pack Type",
    type: "text",
    // errorMsg: "Pack type is required",
    // required: true,
    disabled: true,
  },
  vDONo: {
    name: "vDONo",
    label: "DO No",
    type: "text",
    errorMsg: "DO No is required.",
    required: true,
    // onChange: ((e) => {
    //     console.log(e);
    //     setFieldValue("vDONo", e.target.value);
    // }),
  },
  vInvNo: {
    name: "vInvNo",
    label: "Invoice No",
    type: "text",
    errorMsg: "Invoice no is required",
    required: true,
  },
  recvWh: {
    name: "recvWh",
    label: "Receiving Warehouse",
    type: "select",
    required: true,
    errorMsg: "Receiving warehouse is required.",
  },
  recvZone: {
    name: "recvZone",
    label: "Receiving Zone",
    type: "select",
    required: true,
    errorMsg: "Receiving zone is required.",
  },
  recvLocation: {
    name: "recvLocation",
    label: "Receiving Location",
    type: "select",
    required: true,
    errorMsg: "Receiving location is required.",
  },
  cartonID: {
    name: "cartonID",
    label: "Carton ID",
    type: "text",
  },
  oln: {
    name: "oln",
    label: "OLN",
    type: "text",
  },
  mln: {
    name: "mln",
    label: "MLN",
    type: "text",
  },
  customsLot: {
    name: "customsLot",
    label: "Customs Lot",
    type: "text",
    size: 3,
  },
  manualLot: {
    name: "manualLot",
    label: "Manual Lot",
    type: "text",
    size: 3,
  },
  manufacturingDate: {
    name: "manufacturingDate",
    label: "Manufacturing Date",
    type: "date",
  },
  expiryDate: {
    name: "expiryDate",
    label: "Expiry Date",
    type: "date",
    // default: 0
  },
  qtyExpected: {
    name: "qtyExpected",
    label: "Quantity Expected",
    type: "number",
    required: true,
    disabled: true,
  },
  qtyReceived: {
    name: "qtyReceived",
    label: "Quantity Received",
    type: "number",
    size: 3,
    required: true,
  },
  uom: {
    name: "uom",
    label: "UOM",
    type: "select",
    required: true,
    disabled: true,
    errorMsg: "UOM is required",
  },
  baseUOM: {
    name: "baseUOM",
    label: "Base UOM",
    type: "text",
    disabled: true,
  },
  condition: {
    name: "condition",
    label: "Condition",
    type: "text",
  },
  quantity: {
    name: "quantity",
    label: "Quantity",
    type: "number",
    disabled: true,
    size: 3,
  },
  currencyCode: {
    name: "currencyCode",
    label: "Currency Code",
    type: "text",
    disabled: true,
  },
  unitPrice: {
    name: "unitPrice",
    label: "Unit Price",
    type: "number",
  },
  remark: {
    name: "remark",
    label: "Remark",
    type: "text",
    size: 3,
  },
  btnApplyDO: {
    name: "vDONo",
    label: "Apply DO",
    type: "button",
    size: 2,
  },
  btnApplyInv: {
    name: "vInvNo",
    label: "Apply Inv",
    type: "button",
    size: 2,
  },
  expiryDateCtrl: { name: "expiryDateCtrl", label: "Expiry Date Control", type: "switch" },
  manDateCtrl: { name: "manDateCtrl", label: "Manufacturing Date Control", type: "switch" },
  manualLotCtrl: { name: "manualLotCtrl", label: "Manual Lot No Control", type: "switch" },
  mlnCtrl: { name: "mlnCtrl", label: "Manufacturing Lot No Control", type: "switch" },
};

const {
  status,
  lineNo,
  poLineNo,
  returnCode,
  coLineNo,
  skuCode,
  packType,
  vDONo,
  vInvNo,
  recvWh,
  recvZone,
  recvLocation,
  cartonID,
  oln,
  mln,
  customsLot,
  manualLot,
  manufacturingDate,
  expiryDate,
  qtyExpected,
  qtyReceived,
  uom,
  baseUOM,
  quantity,
  currencyCode,
  unitPrice,
  remark,
  condition,
  expiryDateCtrl,
  manDateCtrl,
  manualLotCtrl,
  mlnCtrl,
} = formField;

// export const detailRender=[
//   [lineNo, status],
//     // [poNumber, extPONumber],
//     [returnCode, coLineNo],
//     [skuCode, packType],
//     [vDONo,btnApplyDO, vInvNo,btnApplyInv],
//     [{ type: "line" }],
//     [oln],
//     [recvWh, recvZone],
//     [recvLocation],
//     [{ type: "line" }],
//     [mln, cartonID],
//     [manufacturingDate, expiryDate],
//     [manualLot, customsLot],
//     [{ type: "line" }],
//     [qtyExpected, baseUOM],
//     [qtyReceived, uom],
//     [quantity, unitPrice],
//     [currencyCode, remark]
// ]

export const detailRender = [
  [lineNo, returnCode, coLineNo, status],
  [skuCode, packType, vDONo, vInvNo],
  [oln, recvWh, recvZone, recvLocation],
  [mln, cartonID, manufacturingDate, expiryDate],
  [manualLot, customsLot],
  [qtyExpected, baseUOM, unitPrice, currencyCode],
  [qtyReceived, quantity,condition, remark],
];

export const detailValues = getInitialValues(formField);

export const detailValidation = Yup.object().shape({
  //---------------- detail ---------------
  [poLineNo.name]: Yup.number().typeError("Please enter number only"),
  // [asnLineNo.name]: Yup.number().typeError("Please enter number only"),
  [skuCode.name]: Yup.string().nullable().max(50).required(skuCode.errorMsg),
  [expiryDateCtrl.name]: Yup.boolean(),
  [manDateCtrl.name]: Yup.boolean(),
  [manualLotCtrl.name]: Yup.boolean(),
  [mlnCtrl.name]: Yup.boolean(),
  [packType.name]: Yup.string().nullable().max(10).required(packType.errorMsg),
  [vDONo.name]: Yup.string().nullable().max(20).required(vDONo.errorMsg),
  [vInvNo.name]: Yup.string().nullable().max(20).required(vInvNo.errorMsg),
  [recvWh.name]: Yup.string().nullable().max(20).required(recvWh.errorMsg),
  [recvZone.name]: Yup.string().nullable().max(20).required(recvZone.errorMsg),
  [recvLocation.name]: Yup.string().nullable().max(20).required(recvLocation.errorMsg),
  [cartonID.name]: Yup.string().nullable().max(20),
  [oln.name]: Yup.string().nullable().max(20),
  [mln.name]: Yup.string()
    .nullable()
    .max(20)
    .when("mlnCtrl", {
      is: true,
      then: (schema) => schema.required(),
    }),
  [customsLot.name]: Yup.string().nullable().max(20),
  [manualLot.name]: Yup.string()
    .nullable()
    .max(20)
    .when("manualLotCtrl", {
      is: true,
      then: (schema) => schema.required(),
    }),
  [manufacturingDate.name]: Yup.string()
    .nullable()
    .when("manDateCtrl", {
      is: true,
      then: (schema) => schema.required(),
    }),
  [expiryDate.name]: Yup.string()
    .nullable()
    .when("expiryDateCtrl", {
      is: true,
      then: (schema) => schema.required(),
    }),
  [qtyExpected.name]: Yup.number().min(0).typeError("Please enter number only"),
  [qtyReceived.name]: Yup.number().min(0).typeError("Please enter number only").required(),
  [uom.name]: Yup.object()
    .shape({ value: Yup.string().nullable(), label: Yup.string().nullable() })
    .nullable()
    .required(uom.errorMsg),
  [quantity.name]: Yup.number().min(0).typeError("Please enter number only"),
  // [baseUOM.name]: Yup.string().nullable().max(10),
  [currencyCode.name]: Yup.string().nullable().max(10),
  [unitPrice.name]: Yup.string().nullable().max(20),
});
